const PlusCircle = () => {
    return (
        <svg
            width='18'
            height='18'
            viewBox='0 0 18 18'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <g id='PlusCircle'>
                <path
                    id='Vector'
                    d='M9 16.5C13.1421 16.5 16.5 13.1421 16.5 9C16.5 4.85786 13.1421 1.5 9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5Z'
                    stroke='#090B2A'
                    strokeWidth='1.25'
                    strokeMiterlimit='10'
                />
                <path
                    id='Vector_2'
                    d='M5.875 9H12.125'
                    stroke='#090B2A'
                    strokeWidth='1.25'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    id='Vector_3'
                    d='M9 5.875V12.125'
                    stroke='#090B2A'
                    strokeWidth='1.25'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
            </g>
        </svg>
    );
};

export default PlusCircle;
